module.exports = __webpack_public_path__ + "static/media/FeatureBillPayment.a9bc2581.svg";